var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1432 8.3125H4.10152C3.6758 8.3125 3.33069 8.65761 3.33069 9.08333V18.3333C3.33069 18.7591 3.6758 19.1042 4.10152 19.1042H24.1432C24.5689 19.1042 24.914 18.7591 24.914 18.3333V9.08333C24.914 8.65761 24.5689 8.3125 24.1432 8.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5807 6V21.4167",
    stroke: "#37383A",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6641 8.3125H24.1432C24.3477 8.3125 24.5437 8.39371 24.6883 8.53827C24.8329 8.68283 24.9141 8.8789 24.9141 9.08333V18.3333C24.9141 18.5378 24.8329 18.7338 24.6883 18.8784C24.5437 19.023 24.3477 19.1042 24.1432 19.1042H15.6641",
    stroke: "#37383A",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5807 19.1042H4.10152C3.89708 19.1042 3.70102 19.023 3.55646 18.8784C3.4119 18.7338 3.33069 18.5378 3.33069 18.3333V9.08333C3.33069 8.8789 3.4119 8.68283 3.55646 8.53827C3.70102 8.39371 3.89708 8.3125 4.10152 8.3125H12.5807",
    stroke: "#37383A",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60669 12.1667H9.30461",
    stroke: "#37383A",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95569 12.1667V15.6354",
    stroke: "#37383A",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeInput);
export default __webpack_public_path__ + "static/media/FreeInput.c16fc415c6db2ec3a567e8909feb142a.svg";
export { ForwardRef as ReactComponent };